import edit from "./edit.js"
import tips from "./tips.js"
import dateUtils from "./dateUtils.js"
import comUtils from "./comUtils.js"
import arithmetic from "./arithmetic.js"
import dom from "./dom.js"
import when from "./when.js"
export default {
  init(iView,router){
    Object.assign(this,comUtils)
    Object.assign(this,arithmetic)
    Object.assign(this,when)
    this.tips=tips
    this.date=dateUtils
    this.edit=edit
    this.dom=dom
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js